import { createSlice } from "@reduxjs/toolkit";

const markerSlice = createSlice({
  name: "marker",
  initialState: {
    temporaryData: null,
    newPosition: [],
    draggableMode: false,
  },
  reducers: {
    setMarkerData(state, action) {
      state.temporaryData = action.payload;
    },
    setNewPosition(state, action) {
      state.newPosition = action.payload;
    },
    setDraggableMode(state) {
      state.draggableMode = true;
    },
    resetMarkerData(state) {
      state.temporaryData = null;
      state.newPosition = [];
      state.draggableMode = false;
    },
  },
});

export const {
  setMarkerData,
  setNewPosition,
  setDraggableMode,
  resetMarkerData,
} = markerSlice.actions;

export default markerSlice.reducer;
